import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { environment } from 'environments';
import { User } from 'store/types';
import { SortDirection } from 'enums';
import { Compensation, ODataResponse } from 'types';

export const fetchEmployees = createAsyncThunk('get:odata/employees', async () => {
  const url = `${environment.baseApiUrl}odata/employees`;

  const { data } = await axios.get<ODataResponse<User>>(url);

  return data.value;
});

export const fetchRequests = createAsyncThunk('get:odata/requests', async () => {
  const url = `${environment.baseApiUrl}odata/requests?$filter=isDeleted eq false&$orderby=createdOn ${SortDirection.DESC}`;

  const { data } = await axios.get<ODataResponse<Compensation>>(url);

  return data.value;
});

export const fetchCurrentYearRequests = createAsyncThunk('get:odata/requests/currentYear', async () => {
  const year = new Date().getFullYear();
  const filter = `isDeleted eq false and (year(createdOn) eq ${year} or year(targetPeriod) eq ${year})`;
  const url = `${environment.baseApiUrl}odata/requests?$filter=${filter}&$orderby=createdOn ${SortDirection.DESC}`;

  const { data } = await axios.get<ODataResponse<Compensation>>(url);

  return data.value;
});

export const fetchArchiveRequests = createAsyncThunk('get:odata/requests/archive', async () => {
  const year = new Date().getFullYear();
  const filter = `isDeleted eq false and year(createdOn) ne ${year} and year(targetPeriod) ne ${year}`;
  const url = `${environment.baseApiUrl}odata/requests?$filter=${filter}&$orderby=createdOn ${SortDirection.DESC}`;

  const { data } = await axios.get<ODataResponse<Compensation>>(url);

  return data.value;
});

export async function getCompensationByIdAdmin(requestId: string): Promise<Compensation | undefined> {
  const compensationFields =
    'status,type,compensationRequestID,privacyConsent,employeeID,department,employmentStatus,createdOn,amount,currency,targetPeriod,periodId,billedOn,employeeComment,reviewerComment,legalEntity';

  const url = `${environment.baseApiUrl}odata/requests?$filter=compensationRequestID eq ${requestId}&$select=${compensationFields}&$expand=attachments($select=originalName,attachmentID)`;

  const { data } = await axios.get<ODataResponse<Compensation>>(url);

  return data.value && data.value.length ? data.value[0] : undefined;
}
